const AssistantActions = {
  LOADED_LIST: "LOADED_ASSISTANTS_LIST",
  LOADED_ASSISTANT: "LOADED_ASSISTANT",
  CREATED_ASSISTANT: "CREATED_ASSISTANT",
  UPDATED_ASSISTANT: "UPDATED_ASSISTANT",
  DELETED_ASSISTANT: "DELETED_ASSISTANT",
};

export default AssistantActions;
